export const APPLICATION_TYPES = {
  FERTILISER: 'fertiliser',
  CROP: 'crop',
  SEED: 'seed',
  ENVIRONMENTAL_CROPS: 'environmental-crops',
};

export const APP_PRODUCT_TYPE = {
  FERTILISER: 'fertiliser',
  CROP: 'cp',
  SEED: 'seed',
  ENVIRONMENTAL_CROPS: 'environmental-crops',
};

export const FEATURE_FLAGS_CROP_PROTECTION =
  process.env.REACT_APP_FEATURE_FLAGS_CROP_PROTECTION === 'true';

export const FEATURE_FLAGS_SEED = process.env.REACT_APP_FEATURE_FLAGS_SEED === 'true';

export const FEATURE_FLAGS_ENVIRONMENTAL_CROPS =
  process.env.REACT_APP_FEATURE_FLAGS_KINGS_ORDERS === 'true';

export const DEFAULT_USER_APP_TYPE_KEY = 'defaultUserAppType';

export const ENABLED_APP_TYPES = {
  [APPLICATION_TYPES.FERTILISER]: true,
  [APPLICATION_TYPES.CROP]: FEATURE_FLAGS_CROP_PROTECTION,
  [APPLICATION_TYPES.SEED]: FEATURE_FLAGS_SEED,
  [APPLICATION_TYPES.ENVIRONMENTAL_CROPS]: FEATURE_FLAGS_ENVIRONMENTAL_CROPS,
};
